export default function AdminHomeView() {
    return (
        <div className="2xl:p-8 p-4">
            <h1 className="2xl:text-3xl text-xl font-bold mb-4">Admin Dashboard Home</h1>
            <p>Welcome to the admin dashboard. Here you can manage your companies and settings.</p>
        </div>
    );
}